import React, { useState } from 'react';
import '../assets/css/login.css'
import { Alert } from '@mui/joy';
import SchoolImg from '../assets/image/school.png'
import UserImg from '../assets/image/user.png'
import PassworldImg from '../assets/image/passworld.png'
import config from '../config'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import axios from 'axios';
import qs from 'qs';
import SignInModel from '../components/signInModel';
import SignInModelOne from '../components/signModel1';

// eslint-disable-next-line no-useless-escape
const regEmail = new RegExp("^[A-Za-z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$");
const checkboxInput = {
    width: 'auto',
    cursor: "pointer"
}
const spanStyle = {
    color: "#2a97ff",
    cursor: "pointer"
}
function SignUp(props) {
    const [user, setUser] = useState('')
    const [passworld, setPassworld] = useState('')
    const [timer, setTimer] = useState(0)
    const [progressValue, setProgressValue] = useState(0)
    const [school, setSchool] = useState('')
    const [schoolNum, setSchoolNum] = useState('')
    const [schoolName, setSchoolName] = useState('')
    const [schoolShow, setSchoolShow] = useState(false)
    const [isread, setIsread] = useState(false)
    const [open, setOpen] = useState(false)
    const [open2, setOpen2] = useState(false)
    const [alertShow, setAlertShow] = useState(false)
    const [alertStr, setAlertStr] = useState('')

    
    const showAlert = (str) => {
        setAlertStr(str)
        setAlertShow(true)
        setTimeout(() => {
            setAlertShow(false)
        }, 1500);
    }
    const login = () => {
        let schoolStr = schoolNum ? ('@' + schoolNum) : '@cocorobo.cc'
        let email = ''
        let str = user.replace(/(^\s*)|(\s*$)/g, "")
        if (!regEmail.test(str)) {
            email = str + schoolStr
        } else {
            email = str
        }
        if(!isread){
            showAlert(props.lang.read_terms_privacy)
            return;
        }
        if (passworld.length < 6 || /[\u4e00-\u9fa5]/.test(passworld)) {
            showAlert(props.lang.passwordError)
            return;
        }
        let progressTimer = setInterval(() => {
            setProgress()
        }, 100);
        let params = {
            username: email.trim(),
            password: passworld.trim(),
            geetest_challenge: "",
            geetest_validate: "",
            geetest_seccode: "",
            googleId: '',
            identity: 1,
        }
        axios.defaults.withCredentials = true;
        axios.post(`${config.api}api/user`, qs.stringify(params)).then(res => {
            clearInterval(progressTimer)
            if (res.data[0][0].type === 1) {
            } else if(res.data[0][0].type === 0){
                showAlert(props.lang.registered_fail1)
            }
            else {
                showAlert(props.lang.signInFail)
            }
        }).catch(err => {
            showAlert(props.lang.signInFail)
            console.log(err)
        })
    }

    const schoolChange = (e) => {
        let value = e.target.value
        if (value) {
            clearTimeout(timer)
            setTimer(setTimeout(() => {
                getSchool(value)
            }, 500))
        } else {
            setSchoolShow(false)
        }
        setSchool(e.target.value)
    }

    const getSchool = e => {
        // 获取学校信息
        axios.post(`${config.edu}admin/selectorganize`, qs.stringify({ mode: e })).then(res => {
            console.log(res)
            if (res.data.length > 0) {
                setSchoolNum(res.data[0][0].mail)
                setSchoolName(res.data[0][0].name)
                setSchoolShow(true)
            } else {
                setSchoolName(props.lang.notSchool)
                setSchoolNum("")
                setSchoolShow(true)
            }
        }).catch(err => {
            setSchoolName(props.lang.notSchool)
            setSchoolNum("")
            setSchoolShow(true)
        })
    }
    const userChange = (e) => {
        setUser(e.target.value)
    }
    const passworldChange = (e) => {
        setPassworld(e.target.value)
    }
    const enter = (e) => {
        if (e.keyCode === 13) {
            login()
        }
    }

    const setProgress = () => {
        let num = progressValue + 10
        if (num > 80) {
            num = 85
        }
        setProgressValue(num)
    }
    return (
        <div className='login' onKeyDown={enter}>
            {alertShow && <div className='login-Progress'>
                <Alert color="danger">{alertStr}</Alert>
            </div>}
            <div className='login-input'>
                <img src={SchoolImg} alt="school" />
                <input onChange={schoolChange} type="text" onBlur={schoolChange} placeholder={props.lang.schoolName} value={school} />
                {schoolShow && <p style={{ marginTop: 5, textAlign: 'left' }}>{schoolName}</p>}
            </div>
            <div className='login-input'>
                <img src={UserImg} alt="user" />
                <input type="text" onChange={userChange} placeholder={props.lang.username} value={user} />
            </div>
            <div className='login-input'>
                <img src={PassworldImg} alt="passworld" />
                <input type="Password" onChange={passworldChange} placeholder={props.lang.password} value={passworld} />
            </div>
            <div className='login-input'>
                <input type="checkbox" onChange={() => setIsread(!isread)} style={checkboxInput} checked={isread} />
                <span>{props.lang.read}<span style={spanStyle} onClick={() => setOpen(true)}>《{props.lang.terms}》</span>{props.lang.and}<span style={spanStyle} onClick={() => setOpen2(true)}>《{props.lang.privacy}》</span></span>
            </div>
            <div className='login-input'>
                <button onClick={login}>{props.lang.signIn}</button>
            </div>
            <Dialog open={open}
                onClose={() => setOpen(false)}>
                <DialogTitle id="alert-dialog-title" style={{ background: "rgb(61, 103, 188)", color: "white" }}>
                {props.lang.terms}
                </DialogTitle>
                <DialogContent id="modal-desc">
                    <SignInModel />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>{props.lang.close}</Button>
                </DialogActions>
            </Dialog >
            <Dialog
                open={open2}
                onClose={() => setOpen2(false)}
            >
                <DialogTitle id="alert-dialog-title" style={{ background: "rgb(61, 103, 188)", color: "white" }}>
                {props.lang.privacy}
                </DialogTitle>
                <DialogContent id="modal-desc">
                    <SignInModelOne />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen2(false)}>{props.lang.close}</Button>
                </DialogActions>
            </Dialog >
        </div >
    );
};

export default SignUp;